import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".ti-exception {\n  box-sizing: border-box;\n  text-align: center;\n}\n.ti-exception .ti-exception-title-content {\n  font-weight: 400;\n  color: #d0d0d0;\n  font-size: 13px;\n}\n";
styleInject(css_248z);

export { css_248z as default };
